import {
    getMemberhsipPlans,
    addMembershipPlan,
    updateMembershipPlan,
    deleteMembershipPlan,
} from './membershipPlansRequestConfigs';

class MembershipPlansApi {
    getMemberhsipPlans = getMemberhsipPlans;
    addMembershipPlan = addMembershipPlan;
    updateMembershipPlan = updateMembershipPlan;
    deleteMembershipPlan = deleteMembershipPlan;
}

class MembershipPlansFactory {
    membershipPlans = MembershipPlansApi;
    create() {
        return new this.membershipPlans();
    }
}

export const membershipPlans = new MembershipPlansFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/MembershipPlansApi/index.js